import { useCallback } from 'react';
import { coreCatalogItemApi } from '@cp/entities/catalogItem';
import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { ClientProfileViewModel } from '@common/model/client';
import { useRouter } from '@cp/shared/router';
import { RespondToVacancyUseCase } from 'src/features/catalogItem/response';
import { useResponseModal } from './useResponseModal';

export type RespondToVacancyDeps = {
  onNeedLogin: () => void;
  patronage: { check: (u: ClientProfileViewModel) => Promise<boolean>; action: () => void };
};
export const useCreateUseCase = () => {
  const router = useRouter();
  const resolver = useClientWebResolver();
  const onResponseNanny = useResponseModal();
  const [response] = coreCatalogItemApi.endpoints.response.useMutation();
  return useCallback(
    ({ onNeedLogin, patronage }: RespondToVacancyDeps) => {
      return new RespondToVacancyUseCase(response, onNeedLogin, patronage, router, resolver, onResponseNanny);
    },
    [response, router, resolver, onResponseNanny],
  );
};
